/**
 * Copied from https://stackoverflow.com/a/2117523/2800218
 */

export const polyfill = () => {
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
    // eslint-disable-next-line no-bitwise -- this is necessarily a bitwise operation
    (Number(c) ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16)
  );
};

export const needsPolyfill = () => {
  return !('randomUUID' in crypto);
};

export const getRandomUUID = () => {
  if (needsPolyfill()) {
    crypto.randomUUID = polyfill;
  }

  return crypto.randomUUID();
};
